import React, {useEffect, useState} from 'react';
import {
  Pagination,
  Paper, Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import {apiDateTimeStringToDate} from "src/api/apiDateTimeHandler";
import {format} from "date-fns";
import {formatPrice} from "src/functions/priceFormatter";
import userBalanceMutationApi from "src/api/account/userBalanceMutationApi";
import useAuth from "src/hooks/use-auth";

const AccountBalanceList = () => {
  const [userBalanceMutations, setUserBalanceMutations] = useState(null);
  const [userBalanceMutationCount, setUserBalanceMutationCount] = useState(null);
  const [page, setPage] = useState(1);
  const itemsPerPage = 30;
  const pages = Math.ceil((userBalanceMutationCount ?? 0) / itemsPerPage);
  const { refreshMyUser } = useAuth();

  const fetchUserBalanceMutations = async () => {
    const response = await userBalanceMutationApi.retrieveCollection();
    setUserBalanceMutations(response['hydra:member']);
    setUserBalanceMutationCount(response['hydra:totalItems']);
  }

  useEffect(() => {
    fetchUserBalanceMutations();
    refreshMyUser();
  }, [])

  useEffect(() => {
    refreshMyUser();
  }, [page]);

  if (!userBalanceMutations) {
    return <Skeleton variant="rectangular" height="200px" />
  }

  if (0 === userBalanceMutationCount) {
    return <Typography variant="body1">Er is nog geen saldo beschikbaar.</Typography>;
  }

  return (
    <>
      <TableContainer component={Paper} sx={{mb: 1}}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Beschrijving</TableCell>
              <TableCell>Datum</TableCell>
              <TableCell align="right">Totaalbedrag</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userBalanceMutations && userBalanceMutations.map((userBalanceMutation) => (
              <TableRow
                key={userBalanceMutation.id}
              >
                <TableCell>{userBalanceMutation.description}</TableCell>
                <TableCell>{format(apiDateTimeStringToDate(userBalanceMutation.createdAt), 'd MMMM yyyy kk:mm')}</TableCell>
                <TableCell align="right">{formatPrice(userBalanceMutation.amount)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        page={page}
        count={pages}
        onChange={(e, newValue) => setPage(newValue)}
        color="primary"
      />
    </>
  );
}

export default AccountBalanceList;

AccountBalanceList.propTypes = {};

AccountBalanceList.defaultProps = {};
